import { Component, Prop, h } from '@stencil/core';

import { bannerSizeType } from '../../../utils/utils.interactive-banner';
@Component({
  tag: 'banner-disqualified',
  styleUrl: 'banner-disqualified.css',
  shadow: true,
})
export class BannerDisqualified {
  @Prop() showDesktop: boolean = false;
  @Prop() showCondensed: boolean = false;
  @Prop() headingSize: bannerSizeType = 'medium';

  render() {
    const textLink = 'Change vehicle';
    const bannerDisqualifiedClass = {
      'banner-disqualified-class': true,
      'flex-col py-5': !this.showDesktop,
      'flex-row box-border pt-4': this.showDesktop,
    };
    const bannerWarningBlockClass = {
      'flex flex-wrap': true,
      'flex-column': !this.showDesktop,
      'flex-row': this.showDesktop,
    };
    const alertClass = {
      'flex font-medium': true,
      'text-sm basis-full': !this.showDesktop,
      'text-base leading-5 basis-87p pt-1': this.showDesktop,
    };
    const bannerResetClass = {
      'grow-1 basis-13p pt-2': this.showDesktop,
      hidden: !this.showDesktop,
    };
    const bannerReasonListClass = {
      'text-sm leading-5 pt-1': true,
      'columns-2': !this.showCondensed,
      'columns-1': this.showCondensed,
      'basis-2/3': this.showDesktop,
      'basis-full': !this.showDesktop,
      'pb-2': !this.showDesktop && !this.showCondensed,
      'pb-4': !this.showDesktop && this.showCondensed,
    };
    const bannerKBBLogoWithLinkClass = {
      'grow-1': this.showDesktop,
      'basis-full': !this.showDesktop,
    };

    return (
      <div class={bannerDisqualifiedClass}>
        <banner-heading showDesktop={this.showDesktop} headingSize={this.headingSize} />
        <div class={bannerWarningBlockClass}>
          <div class={alertClass}>
            <icon-alert class="fill-white mr-2 mt-0.5 w-4 h-4" /> Your vehicle doesn't qualify for an Instant Cash Offer for one or more reasons:
          </div>
          <banner-reset textLink={textLink} showDesktop={this.showDesktop} class={bannerResetClass} />
          <ul class={bannerReasonListClass}>
            <li>Year, Make, Model and/or Style</li>
            <li>Salvage title or other title issues</li>
            <li>Flood/water damage</li>
            <li>Frame damage</li>
            <li>Mileage or odometer issues</li>
            <li>Auto auction in last 45 days</li>
          </ul>
          <banner-logo textLink={textLink} hiddenOnMobile={false} txtLinkHiddenOnDesktop={true} showDesktop={this.showDesktop} class={bannerKBBLogoWithLinkClass} />
        </div>
      </div>
    );
  }
}
